<template>
    <div>
        <q-dialog v-if="flModal" v-model="flModal">
          <q-layout class="modal-small bg-white">
            <q-header class="bg-primary">
              <q-toolbar>
                <q-toolbar-title>{{ $gettext('ADDITIVE_RENOVATION') }}</q-toolbar-title>
                <q-btn
                @click="fecharModal()"
                flat
                round
                dense
                size="1.5em"
                icon="cancel"
              />
              </q-toolbar>
            </q-header>
            <q-page-container class="card-container-modal">
              <div class="modal-replicate-container">
                <span class="replicate-title">
                  {{ $gettext('ADDITIVE_RENOVATION_TEXT') }}
                </span>
                <div class="replicate-content">
                  <button tabindex="0" @click="adicionarAditivo()" type="button" class="margin8 q-btn q-btn-item non-selectable no-outline q-btn--standard q-btn--rectangle bg-secondary text-white q-btn--actionable q-focusable q-hoverable q-btn--wrap q-btn--active">
                    <span class="q-focus-helper"></span>
                      <span class="q-btn__wrapper col row q-anchor--skip">
                        <span class="q-btn__content text-center col items-center q-anchor--skip justify-center row">
                          {{ $gettext('ADD_ADDITIVE') }}
                        </span>
                    </span>
                  </button>
                  <button tabindex="0" @click="renovarContrato()" type="button" class="margin8 q-btn q-btn-item non-selectable no-outline q-btn--standard q-btn--rectangle bg-secondary text-white q-btn--actionable q-focusable q-hoverable q-btn--wrap q-btn--active">
                    <span class="q-focus-helper"></span>
                      <span class="q-btn__wrapper col row q-anchor--skip">
                        <span class="q-btn__content text-center col items-center q-anchor--skip justify-center row">
                          {{ $gettext('CONTRACT_RONAVATION') }}
                        </span>
                    </span>
                  </button>
                </div>
              </div>
            </q-page-container>
          </q-layout>
      </q-dialog>
    </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'modalContractAdditiveOrRenovation',
  components: {},
  props: {
    flModal: Boolean
  }
})
export default class ModalContractAdditiveOrRenovation extends Vue {
  adicionarAditivo () {
    this.$emit('adicionarAditivo')
  }

  renovarContrato () {
    this.$emit('renovarContrato')
  }

  fecharModal () {
    this.$emit('fecharModal')
  }
}
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.modal-replicate-container {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 200px;
}
.replicate-title {
  font-size: 14pt;
  padding-bottom: 10px;
}
.replicate-content {
  text-align: center;
}
.modal-small {
  height: 300px !important;
  max-height: 300px !important;
  min-height: 300px !important;
  width: 500px !important;
  max-width: 500px !important;
  min-width: 500px !important;
}
.margin8 {
  margin: 8px
}
</style>
